// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 806 ? "user" : chunkId) + "." + {"406":"30b611a2","806":"dcb7b485"}[chunkId] + ".chunk.js";
};